import common from '../common.js';

export default {
    // Notices that haven't finished showing yet, from GET api/SystemNotices/active.
    // Includes ones whose showFrom is still in the future -- R3SystemNotice
    // decides when each one appears. Dates arrive as UTC ISO strings ("...Z").
    async loadActive(context) {
        const data = await common.getRequest(context, null, 'systemnotices/active');

        const notices = data.map((n) => ({
            id: n.systemNoticeId,
            type: n.typeName,
            icon: n.typeIcon,
            typeColor: n.typeColor,
            typeSort: n.typeSort,    // lower = more important
            color: n.color,          // optional; replaces typeColor when set
            title: n.title,
            message: n.message,
            startsAt: n.startsAt,
            endsAt: n.endsAt,
            showFrom: n.showFrom,
            showUntil: n.showUntil,
        }));

        context.commit('SET_LIST', notices);
    },
};
